const INITIAL_STATE = {
  isAuth: false,
  loading: false,
  info: {
    _id: '',
    lecturerId: '',
    fullname: '',
    email: '',
    role: [],
    website: '',
    fileUrl: '',
    fileName: '',
    token: '',
  },
  detail: null,
  detailLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOGIN_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isAuth: true,
        loading: false,
        info: {
          ...state.info,
          ...action.payload,
        },
      };
    case 'LOGIN_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'LOGOUT_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'LOGOUT_SUCCESS':
      return INITIAL_STATE;
    case 'UPDATE_INFO_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'UPDATE_INFO_SUCCESS':
      return {
        ...state,
        loading: false,
        info: {
          ...state.info,
          ...action.payload,
        },
      };
    case 'UPDATE_INFO_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'CHECK_PASSWORD_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'CHECK_PASSWORD_SUCCESS':
      return {
        ...state,
        loading: false,
      };
    case 'CHECK_PASSWORD_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'GET_DETAIL_USER_REQUEST':
      return {
        ...state,
        detailLoading: true,
      };
    case 'GET_DETAIL_USER_SUCCESS':
      return {
        ...state,
        detailLoading: false,
        detail: action.payload,
      };
    case 'GET_DETAIL_USER_FAILURE':
      return {
        ...state,
        detailLoading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js